













































import { Component, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import pdf from "vue-pdf";
import { InsertPreviousEducation } from "@/api/pdOutPatient/pdEducation/pdPreviousEducation";
import { GetKnowledgeFileType } from "@/api/pdOutPatient/pdEducation/pdKnowledge";
@Component({})
export default class PdPreviousEducationPlay extends AbpBase {
  @Prop() pdPreviousEducation: any;
  PreviousEducation: any = {};
  rules = {};
  fileType: any = "";
  currentPage = 0;
  pageCount = 0;
  baseUrl: string = `http://${location.hostname}:${SERVER_PORT}`;

  @Watch("pdPreviousEducation", { immediate: false, deep: true })
  async onKnowledeChanged() {
    if (this.pdPreviousEducation) {
      var newObj = Object.assign({}, this.pdPreviousEducation);
      this.PreviousEducation = newObj;
      this.PreviousEducation.startTime = new Date();
      var res = await GetKnowledgeFileType(this.PreviousEducation.fileName);
      this.fileType = res.objects;
    }
  }

  async submit() {
    this.PreviousEducation.endTime = new Date();
    await InsertPreviousEducation(this.PreviousEducation);
    return true;
  }
  handlePageChange(val: any) {
    this.currentPage = val;
  }
  loadPdfHandler(e) {
    this.currentPage = 1; // 加载的时候先加载第一页
  }

  handleExport() {
    var elemIF = document.createElement("iframe");
    elemIF.src = this.baseUrl+this.PreviousEducation.url;
    elemIF.name = this.PreviousEducation.fileName;
    elemIF.style.display = "none";
    document.body.appendChild(elemIF);
  }
  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdPreviousEducation/pdPreviousEducationPlay.vue